export default __webpack_public_path__ + "static/media/wildlife.b6a7378d.png";